/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsAccountData } from './lds-account.data';
import { ILdsAccountProps } from './lds-account.props.autogenerated';

export interface ILdsAccountViewProps extends ILdsAccountProps<ILdsAccountData> {}

/**
 *
 * LdsAccount component
 * @extends {React.PureComponent<ILdsAccountProps<ILdsAccountData>>}
 */
class LdsAccount extends React.PureComponent<ILdsAccountProps<ILdsAccountData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsAccount;
